/*
 * Venn Platform API 1.0.0 Operations for "tax"
 * Automatically generated file - do not modify!
 */

import type { TaxRateSettings } from '../types';
import type { OperationResult } from '../../utils';
import { buildRequestInit, extractError, retryGeneratedFetch } from '../../utils';

/** Get default tax rate settings */
export async function getTaxRateSettings(signal?: AbortSignal): Promise<OperationResult<TaxRateSettings>> {
  const endpoint = '/api/tax/settings';
  const requestInit = buildRequestInit({ method: 'GET', signal });
  const response = await retryGeneratedFetch('GET', () => fetch(endpoint, requestInit));
  if (response.status >= 200 && response.status < 400) {
    const content: TaxRateSettings = (await response.json()) as TaxRateSettings;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
/** Save default tax rate settings */
export async function updateTaxRateSettings(
  body?: Partial<TaxRateSettings>,
  signal?: AbortSignal,
): Promise<OperationResult<TaxRateSettings>> {
  const endpoint = '/api/tax/settings';
  const requestInit = buildRequestInit({
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
    signal,
  });
  const response = await fetch(endpoint, requestInit);
  if (response.status >= 200 && response.status < 400) {
    const content: TaxRateSettings = (await response.json()) as TaxRateSettings;
    return {
      content,
      status: response.status,
      headers: {},
    };
  }
  throw await extractError(response);
}
